var _rect, _polyline, _path, _polyline2, _path2, _line, _line2, _line3, _line4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.093,
    y: 14.642,
    width: 23.814,
    height: 6.55
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "13.858 21.41 13.858 29.75 11.642 29.75 11.642 21.41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.642,14.642v-1.284c0-.612.496-1.108,1.108-1.108h0c.612,0,1.108.496,1.108,1.108v1.284"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "30.358 21.41 30.358 29.75 28.142 29.75 28.142 21.41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.142,14.642v-1.284c0-.612.496-1.108,1.108-1.108h0c.612,0,1.108.496,1.108,1.108v1.284"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.499,
    y1: 20.889,
    x2: 15.763,
    y2: 14.626
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.86,
    y1: 21.108,
    x2: 21.342,
    y2: 14.626
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.356,
    y1: 21.191,
    x2: 26.921,
    y2: 14.626
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 25.935,
    y1: 21.191,
    x2: 32.501,
    y2: 14.626
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18.549
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBarrier);
export default __webpack_public_path__ + "static/media/indoor-barrier.7afc9e1696b776322b27224e72384898.svg";
export { ForwardRef as ReactComponent };